<template>
  <b-row class="d-flex my-4 border-bottom pb-2">
    <b-col class="order-2 order-md-1 my-2" cols="12" md="5">
      <h1 class="my-auto mb-2">{{ title }}</h1>
      <b-breadcrumb :items="breadcrumbs"></b-breadcrumb>
    </b-col>
    <b-col
      v-if="!$route.path.includes('edit') && !$route.path.includes('create')"
      class="order-1 order-md-2 d-flex justify-content-md-end justify-content-center align-items-end m-auto"
      cols="12"
      md="7"
    >
      <b-button
        class="button mb-2 ml-3 fw-600 text-nowrap"
        :to="{ name: 'configurations-legal-mentions' }"
        :class="[$route.name == 'configurations-legal-mentions' ? 'btn-green' : 'btn-grey']"
      >
        <font-awesome-icon class="agv-button-icon" icon="cog" />
        <span class="button-text">{{ $t("configuration_settings.titleLegalMentions") }}</span>
      </b-button>

      <b-button
        class="button mb-2 ml-3 fw-600 text-nowrap"
        :to="{ name: 'configurations-pdf' }"
        :class="[$route.name == 'configurations-pdf' ? 'btn-green' : 'btn-grey']"
      >
        <font-awesome-icon class="agv-button-icon" icon="cog" />
        <span class="button-text">{{ $t("configuration_settings.titlePdfSettings") }}</span>
      </b-button>

      <b-button
        class="button mb-2 ml-3 fw-600 text-nowrap"
        :to="{ name: 'configurations-agency-lre' }"
        :class="[$route.name == 'configurations-agency-lre' ? 'btn-green' : 'btn-grey']"
      >
        <font-awesome-icon class="agv-button-icon" icon="cog" />
        <span class="button-text">{{ $t("configuration_settings.titleAgencyLRESettings") }}</span>
      </b-button>
    </b-col>
  </b-row>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: "",
    },
    breadcrumbLast: {
      type: String,
      default: "",
    },
    breadcrumbRouteText: {
      type: String,
      default: "",
    },
    breadcrumbRouteName: {
      type: String,
      default: "",
    },
  },
  computed: {
    breadcrumbs() {
      if (!this.$route.path.includes("edit") && !this.$route.path.includes("create")) {
        return [
          {
            text: "Accueil",
            to: {
              name: "home",
            },
          },
          {
            text: "Configurations",
            to: {
              name: "configurations",
            },
          },
          {
            text: this.breadcrumbLast,
            active: true,
          },
        ];
      } else {
        return [
          {
            text: "Accueil",
            to: {
              name: "home",
            },
          },
          {
            text: "Configurations",
            to: {
              name: "configurations",
            },
          },
          {
            text: this.breadcrumbRouteText,
            to: {
              name: this.breadcrumbRouteName,
            },
          },
          {
            text: this.breadcrumbLast,
            active: true,
          },
        ];
      }
    },
  },
};
</script>
